import {
  // SAVE_ADDRESS,
  // SAVE_ADDRESS_SUCCEED,
  // SAVE_ADDRESS_FAILED,
  // UPDATE_ADDRESS,
  // UPDATE_ADDRESS_SUCCEED,
  // UPDATE_ADDRESS_FAILED,
  // DELETE_ADDRESS,
  // DELETE_ADDRESS_SUCCEED,
  // DELETE_ADDRESS_FAILED,
  FETCH_ADDRESS,
  FETCH_ADDRESS_SUCCEED,
  FETCH_ADDRESS_FAILED,
} from '../actions/white_list/action_types';

export default (state = {
  whiteList: [],
  isLoading: false,
}, action) => {
  switch (action.type) {
    case FETCH_ADDRESS:
      return {
        ...state,
        isLoading: true,
      };
    case FETCH_ADDRESS_SUCCEED:
      return {
        ...state,
        whiteList: action.params.data,
        isLoading: false,
      };
    case FETCH_ADDRESS_FAILED:
      return {
        ...state,
        whiteList: [],
        isLoading: false,
      };
      // case DELETE_ADDRESS_SUCCEED:
      // 	return {
      // 		...state,
      // 		whiteList: action.params.data,
      // 	};
      // case UPDATE_ADDRESS_SUCCEED:
      // 	return {
      // 		...state,
      // 		whiteList: action.params.data,
      // 	};
      // case SAVE_ADDRESS_SUCCEED:
      // 	return {
      // 		...state,
      // 		whiteList: action.params.data,
      // 	};
    default:
      return {
        ...state,
      };
  }
};
